import { useState } from "react";
import { forgotPasswordSendMail } from "./authService";
import useBootstrapCSS from "../../hooks/useBootstrapCSS";
import codLogo from "./CoD-Logo.png";
import "./login.css";

const ForgotPassword = () => {
    useBootstrapCSS();
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState({ text: "", type: "" });
    const [showModal, setShowModal] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage({ text: "", type: "" });

        try {
            const result = await forgotPasswordSendMail(email);
            if (result.success) {
                setShowModal(true);
            } else {
                setMessage({ text: "Failed to send email. Please try again.", type: "fail" });
            }
        } catch (error) {
            setMessage({ text: "An error occurred. Please try again.", type: "fail" });
        }
    };

    const handleModalOk = () => {
        setShowModal(false);
        window.location.href = "/login";
    };

    return (
        <section className="login-page">
            <div className="container-fluid">
                <div className="row align-items-center h-100">
                    <div className="col-md-6 col-sm-12 px-5 left-graphic">
                        <img src={codLogo} className="img-fluid" alt="CoD Logo" />
                    </div>

                    <div className="col-md-6 col-sm-12 px-5 form-outer h-100 align-items-center d-flex justify-content-center">
                        <form className="initial-form" onSubmit={handleSubmit}>
                            <h3 className="h3 mb-4">Forgot Password</h3>

                            <div className="form-group mb-20">
                                <label htmlFor="loginEmail">Email</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    id="loginEmail"
                                    placeholder="Enter Email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>

                            <p className="mb-30">
                                Once you submit the email, you'll receive a confirmation email
                                shortly after. This email will contain a link that you can use
                                to reset your password.
                            </p>

                            <div className="w-100 d-inine">
                                <button type="submit" className="btn btn-primary mb-30">
                                    Submit
                                </button>
                            </div>

                            {message.text && (
                                <div className={`message ${message.type === "success" ? "successmessage" : "failmessage"}`}>
                                    {message.text}
                                </div>
                            )}
                        </form>
                        <div className="form-footer">
                            <p>Copyright &copy; {new Date().getFullYear()} Compliance on Demand. All Rights Are Reserved.</p>
                        </div>
                    </div>
                </div>
            </div>

            {showModal && (
                <div className="login-modal-overlay">
                    <div className="login-modal">
                        <div className="login-modal-header">
                            <h5>Confirm to Continue</h5>
                            <button className="close-btn" onClick={() => setShowModal(false)}>
                                &times;
                            </button>
                        </div>
                        <div className="login-modal-body">
                            <p>A confirmation email has been sent to your email address.</p>
                        </div>
                        <div className="login-modal-footer">
                            <button className="btn btn-primary" onClick={handleModalOk}>
                                Ok
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
};

export default ForgotPassword;
